import {
  Temple,
  TemplePayload,
} from '@a4b/api/src/modules/Monetisation/Puja/types/templeTypes'

export const getTemplePayload = (
  temple: Temple,
  active: boolean,
): TemplePayload => {
  return {
    title_hi: temple.title_hi,
    title_en: temple.title_en,
    image: temple.image,
    description: temple.description,
    city: temple.city,
    state: temple.state,
    active: active,
  }
}
